module.exports = __webpack_public_path__ + "static/media/status-partial.f3b9b561.svg";